import { useMutation, useQuery } from '@tanstack/react-query';
import { healthCheckApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/**
 * On-demand only: the panel renders nothing until the operator presses
 * Refresh, so this never fetches on mount or focus.
 */
export function useDatabaseStatus() {
  return useQuery({
    queryKey: queryKeys.healthcheck.dbStatus(),
    queryFn: ({ signal }) =>
      healthCheckApiClient.getDatabaseStatuses(toCancelToken(signal)),
    enabled: false,
    staleTime: 0,
    gcTime: 0,
    retry: false,
    meta: { suppressErrorToast: true, errorContext: 'database status' },
  });
}

export function useEnqueueTestJob() {
  return useMutation({
    mutationFn: () => healthCheckApiClient.testJob(),
    meta: { errorContext: 'enqueue test job' },
  });
}

export function useSendTestEmail() {
  return useMutation({
    mutationFn: () => healthCheckApiClient.sendTestEmail(),
    meta: { suppressErrorToast: true, errorContext: 'send test email' },
  });
}

export function useSendTestTimesheetEmail() {
  return useMutation({
    mutationFn: () => healthCheckApiClient.sendTestTimesheetEmail(),
    meta: {
      suppressErrorToast: true,
      errorContext: 'send test timesheet email',
    },
  });
}
